import { NumberInput, type NumberInputProps } from '@mantine/core';

/**
 * Euro-Betragsfeld (F11, Optimierung 2026-08-25): die deutschen
 * Trennzeichen-Props standen neunmal einzeln an den NumberInputs — mit
 * stiller Divergenz (eine Stelle ohne thousandSeparator las „1,5" als 15,
 * dokumentiert im DocumentEditor). Der Wrapper macht die Bug-Klasse zu.
 */
export function EuroInput(props: NumberInputProps) {
  return <NumberInput decimalScale={2} decimalSeparator="," thousandSeparator="." {...props} />;
}
